import React from 'react';

const About = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="hero-section">
          <h1>About Black Sheep Development</h1>
        </div>

        <div className="content-section">
          <div className="content-grid">
            <div className="content-block">
              <h2>Getting Started</h2>
              <p>
                We're just getting on our hooves, please be patient as we grow and improve. Thank you for your interest!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;